import { useConexaQuery } from '@/hooks/useConexaQuery'
import { RealtimeAttendanceMonitoringService } from '../services'

const TWENTY_SECONDS_IN_MS = 20000

export const useGetRealtimeAppointments = (
  patientId: string | number,
  interval = TWENTY_SECONDS_IN_MS,
) => {
  return useConexaQuery({
    queryKey: ['realtiment-appointment', patientId],
    service: () =>
      RealtimeAttendanceMonitoringService.getAppointmentStatus(patientId),
    config: {
      initialData: [],
      enabled: Boolean(patientId),
      refetchOnWindowFocus: true,
      refetchIntervalInBackground: true,
      refetchInterval: interval,
    },
  })
}
